export const RichText = ({
  lines,
  highlightClass = 'text-primary',
}) => {
  return (
    <>
      {lines.map((line, i) => (
        <span key={i} className="block ">
          {line.map((token, j) => (
            <span
              key={j}
              className={token.highlight ? highlightClass : ''}
            >
              {token.text}
            </span>
          ))}
        </span>
      ))}
    </>
  );
};
